import config from 'constants/config'

function getLoyaltyTierDisplayName(tier: App.LoyaltyTier): string {
  return config.loyalty.tiers[tier]?.displayName ?? ''
}

export default getLoyaltyTierDisplayName
